import moment from 'moment-timezone';
import { AxiosInstance } from "./AxiosInstance"


const getHeader = (locationTimezone = '') => {
    const userAuthToken = localStorage.getItem("userAuthToken");
    const timezone = (locationTimezone === '') ? moment.tz.guess() : locationTimezone; // Get device's current time zone
    const headers = {
        timezone: timezone, 
        forceupdate: '1',
        Authorization: "Bearer " + userAuthToken  , //the token is a variable which holds the token
        // Authorization: "Bearer " + "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6IjY4NWNkZDM4Zjk0ODk5NWI0MmQ5OGRjYSIsImlhdCI6MTc3ODQ5NTg5MywiZXhwIjoxODEwMDMxODkzfQ.gdI9ftgn3NOGq8_RB73OPzI__MB2ScTg3VXPaKn0D7I", //the token is a variable which holds the token
    };

    return headers;
}

const getRequest = async (path) => {
    let res = {
        success: false,
        message: "Something went wrong, please try again later",
    };
    try {
        const res = await AxiosInstance.get(path, { headers: getHeader() });
        return res.data;
    }
    catch (err) {
        if (err.response?.status === 401) { return null; }
        throw err;
    }
}

const postRequest = async (path, data, timezone = '') => {
    let res = {
        success: false,
        message: "Something went wrong, please try again later",
    };
    try {
        const res = await AxiosInstance.post(path, data, { headers: getHeader(timezone) });
        return res.data;
    }
    catch (err) {
        throw err;
    }
}

const putRequest = async (path, data ) => {
    let res = {
        success: false,
        message: "Something went wrong, please try again later",
    };
    try {
        const res = await AxiosInstance.put(path, data, { headers: getHeader() });
        return res.data;
    }
    catch (err) {
        return err;
    }
}

const patchRequest = async (path, data) => {
    let res = {
        success: false,
        message: "Something went wrong, please try again later",
    };
    try {
        const res = await AxiosInstance.patch(path, data, { headers: getHeader() });
        return res.data;
    }
    catch (err) {
        return err;
    }
}

const deleteRequest = async (path, data) => {
    let res = {
        success: false,
        message: "Something went wrong, please try again later",
    };
    try {
        const res = await AxiosInstance.delete(path, data, { headers: getHeader() });
        return res.data;
    }
    catch (err) {
        return err;
    }
}

export const login = async (data) => {
    const path = "/v1/dispatcher/auth/login";
    return await postRequest(path, data);
};


export const forgotPassword = async (data) => {
    const path = "/v1/dispatcher/auth/forgotPassword";
    return await postRequest(path, data);
}

export const resetPassword = async (data) => {
    const path = `/v1/dispatcher/auth/resetPassword`;
    return await postRequest(path, data);
}

export const getParkingLocationsAPI = async () => {
   const path = '/v1/dispatcher/parkingLocation/getParkingLocations';
    return await getRequest(path);
}


export const addDriver = async (data) => {
    const path = `/v1/dispatcher/user`;  
    return await postRequest(path, data);
}

export const getDriversList = async () => {
    const path = `/v1/dispatcher/user`;
    return await getRequest(path);
}



// export const getMyVehiclesAPI = async (status="ACTIVE") => {
//     const path = `vehicle/getMyVehicles?status=${status}`;
//     return await getRequest(path);
// }

export const getMyVehicles = async () => {
    const path = `/vehicle/getMyVehicles`;
    return await getRequest(path);
}



export const addVehicle = async (data) => {
    const path = "/vehicle/addVehicle";
    return await postRequest(path, data);
}

export const updateVehicle = async (data) => {
    const path = "/vehicle/updateVehicle";
    return await putRequest(path, data);
}



export const getAddOnServicesList = async({locationId = "", bookingType = ""}) => {
    let path = "/v1/addonService/getAddOnServices";

    if (locationId) {
        path += `?locationId=${encodeURIComponent(locationId)}`;
    }
     if (bookingType) {
        path += `&bookingType=${encodeURIComponent(bookingType)}`;
    }
    return await getRequest(path);
}

export const extendParking = async (data) => {
    const path = `/v1/dispatcher/bookings/extendParking`;
    return await postRequest(path, data);
}

export const singleSlotBooking = async (data, timezone) => {
    const path = `/v1/dispatcher/bookings`  ;
    return await postRequest(path, data);
}

export const multipleSlotBooking = async (data, timezone) => {
    const path = `/v1/dispatcher/bookings/multipleBooking`  ;
    return await postRequest(path, data);
}

export const getSessionStatus = async (sessionId) => {
    const path = `/v1/booking/getCheckoutSessionStatus?sessionId=${sessionId}`;
    return await getRequest(path);
}

export const getActiveBookingsParkingLocation = async () => {
    const path = `/v1/booking/getActiveBookingsParkingLocation`;
    return await getRequest(path);
}



export const getCameras = async (parkingLocationId) => {
    const path = `/v1/camera/getCameras?parkingLocationId=${parkingLocationId}`;
    return await getRequest(path);
}

export const getCameraLiveStreaming = async (cameraData) => {
    const path = `/v1/camera/cameraLiveStreaming`;
    return await postRequest(path, {
        cameras: cameraData
    });
}


 

export const getBookingHistoryAPI = async ({page="", limit=10, search="", status="ALL", locationId='',startDate='',endDate=''}) => {
    const path = `/v1/dispatcher/bookings/history?page=${page}&limit=${limit}&search=${search}&status=${status}&parkingLocationId=${locationId}&startDate=${startDate}&endDate=${endDate}`;
    return await getRequest(path);
}

export const getMultipleBookingHistoryAPI = async ({page="", limit=10,  search="", status="ALL", locationId='',startDate='',endDate=''}) => {
    const path = `/v1/dispatcher/bookings/multipleBookingHistory?page=${page}&limit=${limit}&search=${search}&status=${status}&parkingLocationId=${locationId}&startDate=${startDate}&endDate=${endDate}`;
    return await getRequest(path);
}

export const getBookingAnalyticsAPI = async () => {
    const path = `/v1/dispatcher/bookings/bookingHistorySummary`;
    return await getRequest(path);
}

export const getBookingDetailAPI = async (bookingId = "") => {
    const path = `/v1/dispatcher/bookings/booking/${bookingId}`;
    return await getRequest(path);
}

export const sendChatNotification = async (data) => {
    const path = `/user/sendChatNotification`;
    return await postRequest(path, data);
}

export const driverActivityList = async (data, timezone) => {
    const path = `/v1/dispatcher/bookings/driver_activity_list`;
    return await getRequest(path, data);
}

export const driverControlAPI = async ({page=1, limit=10, search=''}) => {
    const path = `/v1/dispatcher/bookings/driver_control?page=${page}&limit=${limit}&search=${search}`;
    return await getRequest(path);
}

export const bookingsAnalyticsApi = async (data, timezone) => {
    const path = `/v1/dispatcher/bookings/analytics`;
    return await getRequest(path, data);
}

export const cancelSubscription = async (data) => {
    const path = `/v1/dispatcher/bookings/cancelSubscription`;
    return await patchRequest(path, data);
}

export const SubscriptionBookingList = async () => {
    const path = `/v1/dispatcher/bookings/subscriptions`; 
    return await getRequest(path);
}


export const SendGateCodetoDriver = async (data) => {
    const path = `/v1/dispatcher/bookings/sendGateCodeToDriver`; 
    return await postRequest(path,data);
}

export const getDriverActivityDetailList = async ({ page = 1, limit = 5, search = "" , status='', locationId=''}) => {
    const path = `/v1/dispatcher/bookings/driverActivityDetailList?page=${page}&limit=${limit}&search=${search}&status=${status}&parkingLocationId=${locationId}`;
    return await getRequest(path);
}


export const getDriverActivityChartAnalytics = async () => {
    const path = `v1/dispatcher/bookings/driverActivityChartAnalytics`; 
    return await getRequest(path);
}

export const getEntryExitActivity = async ({ search = "", activity = "", page = 1, limit = 5, startDate = "", locationId=''}) => {
    const path = `v1/dispatcher/bookings/entry_exit_activity?page=${page}&limit=${limit}&search=${search}&activity=${activity}&startDate=${startDate}&locationId=${locationId}`; 
    return await getRequest(path);
}

export const getBillingInvoicesApi = async ({page = 1, limit = 5}) => {
    const path = `v1/dispatcher/bookings/invoices?page=${page}&limit=${limit}`; 
    return await getRequest(path);
}

export const getBillingTransactionsApi = async ({page = 1, limit = 5, startDate="", endDate=""}) => {
    const path = `v1/dispatcher/bookings/transactions?page=${page}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`; 
    return await getRequest(path);
}

export const getBillingAnalyticsApi = async () => {
    const path = `v1/dispatcher/bookings/billingAnalytics`; 
    return await getRequest(path);
}

export const getBillingOverviewApi = async ({month=null,year=null}) => {
    const path = `v1/dispatcher/bookings/billingOverview?month=${month}&year=${year}`; 
    return await getRequest(path);
}

export const getBillingCategoryAnalyticsApi = async () => {
    const path = `v1/dispatcher/bookings/billingCategoryAnalytics`; 
    return await getRequest(path);
}

export const getVehicleAnalyticsApi = async () => {
    const path = `v1/dispatcher/bookings/vehicleAnalytics`; 
    return await getRequest(path);
}

export const getNotificationsApi = async ({page = 1, limit = 50}) => {
    const path = `v1/notification/getMyNotifications?page=${page}&limit=${limit} `; 
    return await getRequest(path);
}


export const getParkingLocationsDropDownList = async () => {
    const path = `/v1/dispatcher/parkingLocation/getParkingLocationsDropDownList`; 
    return await getRequest(path);
}

export const updateBooking = async (data) => {
    const path = "/v1/dispatcher/bookings/updateBooking";
    return await putRequest(path, data);
}

export const getNotificationsPreference = async () => {
    const path = `/v1/dispatcher/notifications/preference`; 
    return await getRequest(path);
}



export const getRequiredActions = async () => {
    const path = `/v1/legal-documents/action-required`;
    return await getRequest(path);
}

export const submitConsent = async (data) => {
    const path = `/v1/legal-documents/respond-consent`;
    return await postRequest(path, data);
}

export const getRoadsideServiceRequest = async() => {
    let path = "/v1/roadside-membership/pending";
    return await getRequest(path);
}

export const submitRoadsideServiceDetail = async (data) => {
    const path = `/v1/roadside-membership/details`;
    return await postRequest(path, data);
}


export const getDueInvoices = async() => {
    let path = "v1/booking/due-invoices";
    return await getRequest(path);
}
